import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { util } from '../../../classes/util';
import { InputConverter } from '../../../inputConverter';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { isQueryableMapCoreLayer } from '../../../types';
import { BaseComponent } from '../../base.component';
var shortWait = 10;
/** Basic Filter Component - Allows editing of a layer filter */
var BasicFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BasicFilterComponent, _super);
    function BasicFilterComponent(_vcr, changeDetectorRef, toSqlStringService, filterService, layerService, dataDictionaryApi) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.toSqlStringService = toSqlStringService;
        _this.filterService = filterService;
        _this.layerService = layerService;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.openChangeListenerAdded = false;
        _this._summaryItemsString = '';
        _this.userId = null;
        _this.globalFilterOnPrevious = false;
        _this.refiltered = false;
        _this.previousOperator = '';
        _this.previousValue = [];
        _this.customFilteredDistinctValues = [];
        _this.layerColumns = [];
        _this.layerColumnsDisplay = [];
        _this.updateLayerOnApply = true;
        _this.updateQuery = function (query) {
            _this._outsideUpdate = true;
            _this._query = query;
        };
        _this._outsideUpdate = false;
        _this.ondone = new EventEmitter();
        _this.onlayerdata = new EventEmitter();
        _this.workingQueryChange = new EventEmitter();
        _this.onapply = new EventEmitter();
        _this.finalizeQuery = function () {
            _this.query = _this.filterService.getFinalizedQuery(_this.workingQuery);
        };
        _this.refreshSubqueries = util.debounce(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshSubqueriesWork()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, shortWait);
        _this.resetLayerColumnsDisplay = util.debounce(function () { return _this.resetLayerColumnsDisplayWork(); }, shortWait);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onlayerdata', _this.onlayerdata);
        _this.registerEvent('workingQueryChange', _this.workingQueryChange);
        _this.registerEvent('onapply', _this.onapply);
        _this.registerWithMcScope();
        _this.setOperatorOptions();
        return _this;
    }
    Object.defineProperty(BasicFilterComponent.prototype, "summaryItemsString", {
        get: function () {
            return this._summaryItemsString;
        },
        set: function (inputSummary) {
            this._summaryItemsString = inputSummary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (layerId) {
            this.setLayer(layerId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "externalLayerId", {
        get: function () { return this._externalLayerId; },
        set: function (extLayerId) {
            this._externalLayerId = extLayerId;
            this.setLayer(-1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (inputQuery) {
            this._query = inputQuery;
            this.populateWorkingQueryFromQuery();
            this.refreshSubqueries();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "extraFilters", {
        get: function () {
            return this._extraFilters;
        },
        set: function (extraFilters) {
            this._extraFilters = extraFilters;
        },
        enumerable: true,
        configurable: true
    });
    BasicFilterComponent.prototype.selectedFilterColumn = function (subquery, subqueryIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tempValue;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tempValue = subquery.value;
                        subquery.multiValue = null;
                        subquery.value = null;
                        this.changeDetectorRef.detectChanges();
                        if (!(this.layerId > 0 && !(this.esriLayer && this.esriLayer.mapcoreProps && this.esriLayer.mapcoreProps.isExternal))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.filterService.populateDistinctValues(this.layerId, subquery, this.layerQuery, this.workingQuery, this.layerColumns, subqueryIndex, null, this.isPETL)];
                    case 1:
                        subquery = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.filterService.populateExternalDistinctValues(this.externalLayerId, subquery, this.workingQuery, this.workingSql, subqueryIndex)];
                    case 3:
                        subquery = _a.sent();
                        if (this.refiltered && subquery.distinctValues && subquery.distinctValues.some(function (dv) { return dv.value === tempValue; })) {
                            subquery.value = tempValue;
                        }
                        _a.label = 4;
                    case 4:
                        this.refreshSubqueries();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BasicFilterComponent.prototype, "layerRef", {
        get: function () {
            return this._layerRef;
        },
        set: function (value) {
            this._layerRef = value;
            if (value) {
                this.onlayerdata.emit(this._layerRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "workingQuery", {
        get: function () {
            return this._workingQuery;
        },
        set: function (inputQuery) {
            this._workingQuery = inputQuery;
            this.addBottomSubqueryIfNeeded();
        },
        enumerable: true,
        configurable: true
    });
    BasicFilterComponent.prototype.updateWorkingSql = function (summaryString) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.summaryItemsString = summaryString;
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BasicFilterComponent.prototype, "isPETL", {
        get: function () {
            return this.esriLayer ? this.esriLayer.mapcoreProps.isPETL : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "andOr", {
        get: function () {
            return this.workingQuery.operator === 'OR' ? 'or' : 'and';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "showFilter", {
        get: function () {
            return this.layerColumns.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicFilterComponent.prototype, "workingSubqueries", {
        get: function () {
            if (this.workingQuery) {
                return this.workingQuery.subqueries.filter(function (query) { return !(query.subqueries && query.subqueries.length); });
            }
            return null;
        },
        set: function (subqueries) {
            var _a;
            if (this.workingQuery) {
                var deepSubqueries = void 0;
                if (this.workingQuery.subqueries) {
                    deepSubqueries = this.workingQuery.subqueries.filter(function (query) { return query.subqueries && query.subqueries.length; });
                }
                this.workingQuery.subqueries = subqueries;
                if (deepSubqueries) {
                    (_a = this.workingQuery.subqueries).push.apply(_a, tslib_1.__spread(deepSubqueries));
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    BasicFilterComponent.prototype.showMultiple = function (operator) {
        return this.filterService.showMultiple(operator);
    };
    BasicFilterComponent.prototype.addBottomSubqueryIfNeeded = function () {
        if (this.workingSubqueries) {
            var addWorkingSubquery = this.workingSubqueries.length === 0;
            if (!addWorkingSubquery) {
                var lastSubquery = this.workingSubqueries[this.workingSubqueries.length - 1];
                addWorkingSubquery = this.toSqlStringService.queryConditionIsValid(lastSubquery);
            }
            if (addWorkingSubquery) {
                var addQuery = { field: '', operator: '=', value: null, filterDistinctOnPrevious: this.globalFilterOnPrevious ? true : false };
                addQuery.operatorOptions = this.filterService.getOperatorOptionsForSubquery(addQuery, this.layerColumns);
                this.workingQuery.subqueries.push(addQuery);
            }
        }
    };
    BasicFilterComponent.prototype.applyFilter = function () {
        this.finalizeQuery();
        if (this.layerId > 0) {
            this.filterService.saveLayerUsage(this.layerId, this.query);
            var data = { layerId: this.layerId, sql: this.workingSql, query: this.query, parentQuery: this.layerQuery };
            this.ondone.emit(data);
            if (this.updateLayerOnApply) {
                this.onapply.emit({ id: this.layerId.toString(), data: data });
                if (this.esriLayer && data && isQueryableMapCoreLayer(this.esriLayer)) {
                    this.esriLayer.mapcoreProps.filter = data.sql;
                    this.esriLayer.mapcoreProps.query = data.query;
                    this.layerService.updateLayerFilter(this.esriLayer, data.query);
                    this.onapply.emit({ esriLayer: this.esriLayer });
                }
                else {
                    this.onapply.emit(null);
                }
            }
            this.filterService.onApplyFilter(this.esriLayer);
        }
        else if (this.externalLayerId !== undefined) {
            //external layers apply
            var esriLayer = this.layerService.getEsriLayerByUniqueId(this.externalLayerId);
            esriLayer.mapcoreProps.filter = this.workingSql;
            esriLayer.mapcoreProps.query = this.query;
            esriLayer.definitionExpression = this.workingSql;
            this.ondone.emit();
        }
        this.resetBasicFilter();
    };
    BasicFilterComponent.prototype.cancel = function () {
        this.resetBasicFilter();
        this.ondone.emit(null);
    };
    BasicFilterComponent.prototype.emitWorkingQuery = function () {
        if (!this._outsideUpdate) {
            this.workingQueryChange.emit({ workingQuery: this.workingQuery, layerColumns: this.layerColumns });
        }
        this._outsideUpdate = false;
    };
    BasicFilterComponent.prototype.populateWorkingQueryFromQuery = function () {
        if (this.query) {
            this.workingQuery = this.filterService.populateWorkingQueryFromQuery(this.query, this.layerColumns);
            this.addBottomSubqueryIfNeeded();
        }
    };
    BasicFilterComponent.prototype.populateWorkingSql = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.layerId > 0)) return [3 /*break*/, 3];
                        if (!this.table) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.filterService.populateWorkingSql(this.layerQuery, this.workingQuery, this.table, this.layerColumns)];
                    case 1:
                        _a.workingSql = _c.sent();
                        _c.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        if (!this.workingQuery) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this.toSqlStringService.buildExternalWorkingSql(this.workingQuery, this.layerColumns)];
                    case 4:
                        _b.workingSql = _c.sent();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.refreshSubqueriesWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var populatePromises_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filterService.clearValuesIfNeeded(this.workingSubqueries);
                        this.workingSubqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingSubqueries, this.layerColumns);
                        if (!(this.workingSubqueries && this.workingSubqueries.length)) return [3 /*break*/, 2];
                        populatePromises_1 = [];
                        this.workingSubqueries.forEach(function (sq, i) {
                            if (!sq.distinctValues) {
                                populatePromises_1.push(_this.filterService.populateDistinctValues(_this.layerId, sq, _this.layerQuery, _this.workingQuery, _this.layerColumns, i, null, _this.isPETL));
                            }
                        });
                        return [4 /*yield*/, Promise.all(populatePromises_1)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.addBottomSubqueryIfNeeded();
                        this.emitWorkingQuery();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.populateLayerData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, layers, tables, dataDictionaryColumns, _loop_1, _c, _d, layerColumn;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(this._layerId && this._layerId > 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.filterService.getLayerData(this.layerId)];
                    case 1:
                        layers = _e.sent();
                        if (!(layers.length > 0)) return [3 /*break*/, 4];
                        if (this.esriLayer && this.esriLayer.mapcoreProps) {
                            this.layerRef = this.esriLayer.mapcoreProps;
                            this.layerQuery = this.layerRef.parentQuery;
                        }
                        else {
                            this.layerRef = layers[0];
                            this.layerQuery = this.layerRef.queryJSON ? JSON.parse(this.layerRef.queryJSON) : this.filterService.getEmptyQuery();
                        }
                        this.replacePlanYearNoQuery();
                        this.replaceParentQuery();
                        tables = this.layerRef.tables;
                        this.table = tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0];
                        dataDictionaryColumns = void 0;
                        if (!(this.table && this.table.metaTable)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.table.metaTable.id)];
                    case 2:
                        dataDictionaryColumns = _e.sent();
                        _e.label = 3;
                    case 3:
                        if (!this.layerColumns.length && this.layerRef && this.layerRef.columns) {
                            (_a = this.layerColumns).push.apply(_a, tslib_1.__spread(this.layerRef.columns));
                        }
                        _loop_1 = function (layerColumn) {
                            layerColumn.name = layerColumn.name.toLowerCase();
                            if (!layerColumn.alias) {
                                layerColumn.alias = layerColumn.name.toUpperCase();
                            }
                            if (dataDictionaryColumns) {
                                var matchingColumn = dataDictionaryColumns.find(function (c) { return c.columnName.toLowerCase().trim() === layerColumn.name.toLowerCase().trim(); });
                                if (matchingColumn && matchingColumn.domainValues && matchingColumn.domainValues.length) {
                                    layerColumn.domainValues = matchingColumn.domainValues;
                                }
                            }
                        };
                        try {
                            for (_c = tslib_1.__values(this.layerColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                                layerColumn = _d.value;
                                _loop_1(layerColumn);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.layerColumnsDisplay = this.layerColumns;
                        this.sortLayerColumnsDisplay();
                        return [2 /*return*/, this.layerColumns];
                    case 4: return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.populateExternalLayerData()];
                    case 6:
                        _e.sent();
                        _e.label = 7;
                    case 7:
                        this.sortLayerColumnsDisplay();
                        return [2 /*return*/, []];
                }
            });
        });
    };
    BasicFilterComponent.prototype.populateExternalLayerData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, esriLayer, i, _b, _c, sq, e_2_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        esriLayer = this.layerService.getEsriLayerByUniqueId(this.externalLayerId);
                        this.layerColumns.length = 0;
                        this.layerColumns = tslib_1.__spread(this.esriLayer.mapcoreProps.columns);
                        if (!esriLayer.mapcoreProps.query) return [3 /*break*/, 8];
                        this.refiltered = true;
                        this.workingSubqueries = this.workingQuery.subqueries;
                        if (!(this.workingSubqueries.length !== 0)) return [3 /*break*/, 8];
                        i = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(this.workingSubqueries), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        sq = _c.value;
                        if (!sq.value && !sq.field) {
                            return [3 /*break*/, 5];
                        }
                        return [4 /*yield*/, this.selectedFilterColumn(sq, i)];
                    case 3:
                        _d.sent();
                        i++;
                        _d.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.layerColumnsDisplay = tslib_1.__spread(this.layerColumns);
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.remove = function (i) {
        this.workingSubqueries = this.workingSubqueries.filter(function (_sq, index) { return index !== i; });
        this.refreshSubqueries();
    };
    BasicFilterComponent.prototype.setAll = function () {
        this.workingQuery.operator = 'AND';
        this.refreshSubqueries();
    };
    BasicFilterComponent.prototype.setAny = function () {
        this.workingQuery.operator = 'OR';
        this.refreshSubqueries();
    };
    BasicFilterComponent.prototype.setLayer = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._layerId = layerId;
                        this.workingSql = '';
                        this.layerRef = undefined;
                        this.table = null;
                        this.layerColumns.length = 0;
                        this.layerColumnsDisplay.length = 0;
                        return [4 /*yield*/, this.populateLayerData()];
                    case 1:
                        _a.sent();
                        if (!this.refiltered) {
                            this.populateWorkingQueryFromQuery();
                            this.refreshSubqueries();
                            this.refiltered = false;
                        }
                        else {
                            this.workingSubqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingSubqueries, this.layerColumns);
                            this.changeDetectorRef.detectChanges();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.setOperatorOptions = function () {
        this.operatorOptions = this.toSqlStringService.getOperatorOptions();
    };
    BasicFilterComponent.prototype.setFilterOnPrevious = function (subquery, singleSubQueryIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!subquery) return [3 /*break*/, 5];
                        subquery.previousFilterDistinctOnPreviousValue = subquery.filterDistinctOnPrevious;
                        subquery.filterDistinctOnPrevious = subquery.filterDistinctOnPrevious ? false : true;
                        if (!(this.layerId > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.filterService.populateDistinctValues(this.layerId, subquery, this.layerQuery, this.workingQuery, this.layerColumns, singleSubQueryIndex, null, this.isPETL)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.filterService.populateExternalDistinctValues(this.externalLayerId, subquery, this.workingQuery, this.workingSql, singleSubQueryIndex)];
                    case 3:
                        _a.sent();
                        if (!subquery.distinctValues.some(function (dv) { return dv.value === subquery.value; })) {
                            subquery.value = '';
                            this.refreshSubqueries();
                        }
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        // Looping through all subqueries to filter by previous in turn. Does not apply to first subquery
                        this.globalFilterOnPrevious = this.globalFilterOnPrevious ? false : true;
                        this.workingQuery.subqueries.forEach(function (workingSubquery, i) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sq_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        workingSubquery.previousFilterDistinctOnPreviousValue = workingSubquery.filterDistinctOnPrevious;
                                        workingSubquery.filterDistinctOnPrevious = this.globalFilterOnPrevious ? true : false;
                                        if (!(i > 0)) return [3 /*break*/, 4];
                                        sq_1 = this.workingQuery.subqueries[i];
                                        if (!(this.layerId > 0)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.filterService.populateDistinctValues(this.layerId, sq_1, this.layerQuery, this.workingQuery, this.layerColumns, i, null, this.isPETL)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 4];
                                    case 2:
                                        if (!sq_1) return [3 /*break*/, 4];
                                        return [4 /*yield*/, this.filterService.populateExternalDistinctValues(this.externalLayerId, sq_1, this.workingQuery, this.workingSql, i)];
                                    case 3:
                                        _a.sent();
                                        if (sq_1.distinctValues && sq_1.value && !sq_1.distinctValues.some(function (dv) { return dv.value === sq_1.value; })) {
                                            sq_1.value = '';
                                            this.refreshSubqueries();
                                        }
                                        _a.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        _a.label = 6;
                    case 6:
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.toggleShowSql = function () {
        this.showSQL = !this.showSQL;
    };
    BasicFilterComponent.prototype.replaceParentQuery = function () {
        //Replace the parent query from the extra filter if there are any cyfy there.
        if (this.extraFilters && this.extraFilters.length > 0 && this.extraFilters[0].field === 'MAINT_FY') {
            var layerFieldName = 'CALENDAR_YEAR', field = 'cy_plan_year_no', fieldToReplace = 'fy_plan_year_no', extraFilter = this.extraFilters[0];
            this.replaceFields(extraFilter, layerFieldName, field, fieldToReplace);
        }
        else if (this.extraFilters && this.extraFilters.length > 0 && this.extraFilters[0].field === 'CALENDAR_YEAR') {
            var layerFieldName = 'MAINT_FY', field = 'fy_plan_year_no', fieldToReplace = 'cy_plan_year_no', extraFilter = this.extraFilters[0];
            this.replaceFields(extraFilter, layerFieldName, field, fieldToReplace);
        }
    };
    BasicFilterComponent.prototype.replacePlanYearNoQuery = function () {
        var fieldName = this.getQueryFieldName(this.query, 'plan_year_no', '{replaceYear}', true);
        if (fieldName) {
            this.layerQuery.field = fieldName;
        }
    };
    BasicFilterComponent.prototype.getQueryFieldName = function (query, fieldName, value, removeQuery) {
        if (removeQuery === void 0) { removeQuery = false; }
        if (query) {
            if (query.subqueries && query.subqueries.length && query.subqueries.length > 0) {
                for (var i = query.subqueries.length - 1; i >= 0; i--) {
                    var returnText = this.getQueryFieldName(query.subqueries[i], fieldName, value);
                    if (returnText) {
                        if (removeQuery && query.subqueries[i].field && query.subqueries[i].field.indexOf(fieldName) > -1 && query.subqueries[i].value.indexOf(value) > -1) {
                            query.subqueries[i] = null;
                            query.subqueries = query.subqueries.filter(function (x) { return x; });
                        }
                        return returnText;
                    }
                }
            }
            else if (query.field && query.field.indexOf(fieldName) > -1 && query.value.indexOf(value) > -1) {
                var field = query.field.toString();
                return field;
            }
        }
        return null;
    };
    BasicFilterComponent.prototype.replaceFields = function (extraFilter, layerFieldName, field, fieldToReplace) {
        var e_3, _a;
        if (this.layerQuery && this.layerQuery.field && this.layerQuery.field.toUpperCase() === layerFieldName) {
            this.layerQuery.field = extraFilter.field;
            this.layerQuery.value = extraFilter.value;
        }
        else if (this.layerQuery && this.layerQuery.field) {
            if (this.layerQuery.field.toLowerCase() === field) {
                this.layerQuery.field = fieldToReplace;
            }
        }
        else if (this.layerQuery && this.layerQuery.subqueries) {
            try {
                for (var _b = tslib_1.__values(this.layerQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var q = _c.value;
                    if (q.field && q.field.toUpperCase() === layerFieldName) {
                        q.field = extraFilter.field;
                        q.value = extraFilter.value;
                    }
                    else if (q.field && q.field.toLowerCase() === field) {
                        q.field = fieldToReplace;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    BasicFilterComponent.prototype.valueChangeOperator = function (index) {
        var _this = this;
        if (this.workingSubqueries[index].operator) {
            // If operator is for multiple values, ensure selected values are in list of values
            // Else if operator includes NULL and a value is set, then save current value to possibly restore later since it is cleared
            // Else if operator does not include NULL and value is empty, then restore previous value
            if (this.filterService.showMultiple(this.workingSubqueries[index].operator) && !this.filterService.showMultiple(this.previousOperator)) {
                var selectedValues = [];
                if (this.workingSubqueries[index].multiValue) {
                    selectedValues = this.workingSubqueries[index].multiValue;
                }
                if (this.workingSubqueries[index].value) {
                    selectedValues = this.workingSubqueries[index].value.split(',').filter(function (v) { return v.trim() !== ''; });
                }
                // Go through all selected values
                selectedValues.forEach(function (value) {
                    // If value not in list, then add custom value to lists
                    if (_this.workingSubqueries[index].filteredDistinctValues.filter(function (distinctValue) { return distinctValue.value === value; }).length === 0) {
                        _this.workingSubqueries[index].customValues.push(value);
                        _this.workingSubqueries[index].filteredDistinctValues.push({ text: value, value: value });
                    }
                });
            }
            else if (this.workingSubqueries[index].operator.includes('NULL') && this.workingSubqueries[index].value != undefined) {
                this.previousValue[index] = this.workingSubqueries[index].value;
            }
            else if (!this.workingSubqueries[index].operator.includes('NULL') && this.workingSubqueries[index].value === '') {
                this.workingSubqueries[index].value = this.previousValue[index];
                this.previousValue[index] = '';
            }
            this.previousOperator = this.workingSubqueries[index].operator;
        }
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    BasicFilterComponent.prototype.valueChange = function () {
        var _this = this;
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    BasicFilterComponent.prototype.valueChangeComboBox = function (value, index) {
        var _this = this;
        if (!this.workingSubqueries[index].customValues) {
            this.workingSubqueries[index].customValues = [];
        }
        var filteredDistinctValues = [];
        // If removing value
        // Otherwise, value selected
        if (value === undefined) {
            // If value is a custom value
            if (this.workingSubqueries[index].customValues.length > 0) {
                // Go through all custom values
                this.workingSubqueries[index].customValues.forEach(function (customValue) {
                    // Determine if custom value is in list
                    filteredDistinctValues = _this.workingSubqueries[index].filteredDistinctValues.filter(function (distinctValue) { return distinctValue.value === customValue; });
                    // If custom value is in list, then remove it
                    if (filteredDistinctValues.length === 1) {
                        _this.removeItemFromFilteredDistinctValues(index, customValue);
                    }
                });
                // Remove custom values (may be more than one if had multiple initially selected and then changed operator)
                this.workingSubqueries[index].customValues = [];
            }
        }
        else {
            // Determine if value is in list
            filteredDistinctValues = this.workingSubqueries[index].filteredDistinctValues.filter(function (distinctValue) { return distinctValue.value === value; });
            // If custom value not in list
            // Otherwise, not custom value
            if (filteredDistinctValues.length === 0) {
                // If custom value is not empty string
                if (value !== '') {
                    // If existing custom value, then remove
                    if (this.workingSubqueries[index].customValues.length === 1) {
                        this.removeItemFromFilteredDistinctValues(index, this.workingSubqueries[index].customValues[0]);
                    }
                    // Add custom value to lists
                    this.workingSubqueries[index].customValues = [value];
                    this.workingSubqueries[index].filteredDistinctValues.push({ text: value, value: value });
                    // Save list of items before clearing them; will be re-added immediately on close event in order to properly refresh selected item(s)
                    this.customFilteredDistinctValues[index] = this.workingSubqueries[index].filteredDistinctValues;
                    this.workingSubqueries[index].filteredDistinctValues = [];
                }
            }
            else {
                // If there's a custom value, remove it
                if (this.workingSubqueries[index].customValues.length === 1) {
                    // Remove existing custom values (if exist)
                    this.removeItemFromFilteredDistinctValues(index, this.workingSubqueries[index].customValues[0]);
                    // Value not custom value so clear list
                    this.workingSubqueries[index].customValues = [];
                }
            }
        }
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    BasicFilterComponent.prototype.valueChangeMultiSelect = function (values, index) {
        var _this = this;
        var checkCommaDelimited = !this.workingSubqueries[index].filteredDistinctValues
            || !this.workingSubqueries[index].filteredDistinctValues.every(function (dv) { return dv.value.includes(','); });
        if (checkCommaDelimited) {
            values = this.workingSubqueries[index].multiValue = values.flatMap(function (value) {
                var retVal = [value];
                if (value.includes(',')) {
                    retVal = value.split(',').map(function (v) { return v.trim(); });
                }
                return retVal;
            });
        }
        if (!this.workingSubqueries[index].customValues) {
            this.workingSubqueries[index].customValues = [];
        }
        var isItemAdded;
        // Go through all selected values
        values.forEach(function (value) {
            // If not empty string and value not in list, then new custom value
            if (value !== '' && _this.workingSubqueries[index].filteredDistinctValues.filter(function (distinctValue) { return distinctValue.value === value; }).length === 0) {
                // Add custom value to lists
                _this.workingSubqueries[index].customValues.push(value);
                _this.workingSubqueries[index].filteredDistinctValues.push({ text: value, value: value });
                isItemAdded = true;
            }
        });
        if (!isItemAdded) {
            // Go through custom values
            this.workingSubqueries[index].customValues.forEach(function (customValue, valueIndex) {
                // If value not in list, then custom value removed
                if (values.filter(function (distinctValue) { return distinctValue === customValue; }).length === 0) {
                    // Remove custom value from filtered list
                    _this.removeItemFromFilteredDistinctValues(index, customValue);
                    // Remove custom value from custom value list
                    _this.workingSubqueries[index].customValues.splice(valueIndex, 1);
                }
            });
        }
        // Save list of items before clearing them; will be re-added immediately on close event in order to properly refresh selected item(s)
        this.customFilteredDistinctValues[index] = this.workingSubqueries[index].filteredDistinctValues;
        this.workingSubqueries[index].filteredDistinctValues = [];
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    BasicFilterComponent.prototype.removeItemFromFilteredDistinctValues = function (index, value) {
        var _this = this;
        this.workingSubqueries[index].filteredDistinctValues.forEach(function (item, itemIndex) {
            if (item.value === value) {
                _this.workingSubqueries[index].filteredDistinctValues.splice(itemIndex, 1);
            }
        });
    };
    BasicFilterComponent.prototype.openCloseValueSelection = function (index) {
        // If there is a custom value list, then update current list with custom list in order for model/selection behavior to be correct
        if (this.customFilteredDistinctValues[index]) {
            this.workingSubqueries[index].filteredDistinctValues = this.customFilteredDistinctValues[index];
            this.customFilteredDistinctValues[index] = null;
        }
    };
    BasicFilterComponent.prototype.valueNormalizer = function (text$) {
        return text$.pipe(map(function (text) {
            return {
                value: text,
                text: text
            };
        }));
    };
    BasicFilterComponent.prototype.handleFilter = function (value, isColumnName, subquery) {
        if (isColumnName) {
            if (value !== '' && value !== null) {
                this.layerColumnsDisplay = this.layerColumns.filter(function (s) { return util.LooseIncludes(s.name, value) || (s.alias && util.LooseIncludes(s.alias, value)); });
            }
            else {
                this.layerColumnsDisplay = this.layerColumns;
            }
            this.sortLayerColumnsDisplay();
        }
        else if (value.length > 1 && subquery.distinctValues) {
            subquery.filteredDistinctValues = subquery.distinctValues.filter(function (v) { return util.LooseIncludes(v.text, value) || util.LooseIncludes(v.value, value); });
        }
        else {
            subquery.filteredDistinctValues = subquery.distinctValues;
        }
        this.changeDetectorRef.detectChanges();
    };
    BasicFilterComponent.prototype.resetBasicFilter = function () {
        this.query = {};
        this.workingSql = '';
        this.summaryItemsString = '';
        this.extraFilters = [];
        this.esriLayer = null;
    };
    BasicFilterComponent.prototype.resetLayerColumnsDisplayWork = function () {
        this.layerColumnsDisplay = this.layerColumns;
        this.sortLayerColumnsDisplay();
    };
    BasicFilterComponent.prototype.sortLayerColumnsDisplay = function () {
        this.layerColumnsDisplay.sort(function (a, b) {
            var aSortText = a.alias.toLowerCase();
            var bSortText = b.alias.toLowerCase();
            return aSortText.localeCompare(bSortText);
        });
    };
    BasicFilterComponent.prototype.setFilter = function (layerId, esriLayer, layerColumns, query, externalLayerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!externalLayerId) {
                            this._layerId = layerId;
                            this._query = query || {};
                        }
                        else {
                            this._externalLayerId = externalLayerId;
                            layerId = -1;
                            this.query = query || {};
                        }
                        this.esriLayer = esriLayer;
                        this.layerColumns = layerColumns || [];
                        return [4 /*yield*/, this.setLayer(layerId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasicFilterComponent.prototype.selectedColumn = function (column) {
        return this.layerColumnsDisplay.find(function (x) { return x.name === column; });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], BasicFilterComponent.prototype, "updateLayerOnApply", void 0);
    return BasicFilterComponent;
}(BaseComponent));
export { BasicFilterComponent };
